const mod = () => {
  const skuInstanceConfigs = {};
  return {
    addSKUInstanceConfig: (skuInstanceId, skuConfig) => {
      skuInstanceConfigs[skuInstanceId] = skuConfig;
    },
    getSKUInstanceConfig: (skuInstanceId) => {
      return skuInstanceConfigs[skuInstanceId];
    },
  };
};
const SKUInstanceConfigs = mod();
export default SKUInstanceConfigs;
